export default __webpack_public_path__ + "static/media/pic5.04c3c472.jpg";